import { api, LightningElement, wire } from "lwc";
import { localizeDate } from "@devforce/trailhead-client-locale";

import { LabelsAdapter, LabelsAdapterValue } from "common/labelsAdapter";

import { FinishedAtFormat } from "../contentSummary/types";

import { hoursMinutesLeftLabel } from "common/labels";
import * as locales from "./locales";

export default class extends LightningElement {
  @api compact: boolean | string | null = null;
  @api estimatedTimeLeft: number | null = null;
  @api finishedAt: FinishedAtFormat | null = null;
  @api progress: number | null = null;

  @wire(LabelsAdapter, { locales, options: "$labelOptions" })
  private _labels: LabelsAdapterValue = null!;
  private get labels() {
    return {
      ...this._labels,
      completed: this.finishedAt ? this._labels.completed : "",
    };
  }

  private get labelOptions() {
    let finishedAtValue = "";

    if (this.finishedAt) {
      if (typeof this.finishedAt === "string") {
        finishedAtValue = localizeDate(this.finishedAt);
      } else if (this.finishedAt.value) {
        finishedAtValue = this.finishedAt.localize
          ? localizeDate(this.finishedAt.value)
          : this.finishedAt.value;
      }
    }

    return {
      completed: {
        date: finishedAtValue,
      },
    };
  }

  private get isCompact() {
    return typeof this.compact === "boolean"
      ? this.compact
      : this.compact !== null;
  }

  private get valueStyle() {
    return `width: ${this.progress}%`;
  }

  private get showComplete() {
    return this.isFinished();
  }

  private get showProgress() {
    return this.progress != null && !this.isFinished();
  }

  private get showText() {
    return this.progress == null && !this.isFinished();
  }

  private get estimatedTimeLeftLabel() {
    if (this.estimatedTimeLeft) {
      return hoursMinutesLeftLabel(this.estimatedTimeLeft);
    }
    return undefined;
  }

  private get showEstimatedTimeLeft() {
    return !this.isCompact && this.estimatedTimeLeft;
  }

  /**
   * Will return if the item is finished for any option of
   * finishedAt: null, string, object with or without a value
   */
  private isFinished() {
    if (!this.finishedAt) {
      return false;
    }

    return typeof this.finishedAt === "string" || this.finishedAt.value;
  }
}
